import React from "react"

import { connect } from "scrivito"

import { ProductConfiguratorResult } from "widgets/product-configurator/model/useProductConfiguratorModel"

import { ProductConfiguratorModeSelectOverlay } from "./ProductConfiguratorModeSelectOverlay"
import { useProductConfiguratorModeSelectOverlayModel } from "./model/useProductConfiguratorModeSelectOverlayModel"

export interface ProductConfiguratorModeSelectOverlayPayload {
  productType: string
  onProductConfigurationChange: (
    configuration: ProductConfiguratorResult
  ) => void
}

export interface ProductConfiguratorModeSelectOverlayConnectorProps {
  payload: ProductConfiguratorModeSelectOverlayPayload
}

function ProductConfiguratorModeSelectOverlayConnectorComponent(
  props: ProductConfiguratorModeSelectOverlayConnectorProps
) {
  return (
    <ProductConfiguratorModeSelectOverlay
      {...useProductConfiguratorModeSelectOverlayModel(props)}
    />
  )
}

export const ProductConfiguratorModeSelectOverlayConnector = React.memo(
  connect(ProductConfiguratorModeSelectOverlayConnectorComponent)
) as typeof ProductConfiguratorModeSelectOverlayConnectorComponent

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    PRODUCT_CONFIGURATOR_MODE_SELECT_OVERLAY: ProductConfiguratorModeSelectOverlayPayload
  }
}
